import Vue from 'vue'
import App from './App.vue'
import router from './router'

import '../src/assets/css/common.css'
import '../src/assets/css/private.css'
import '../src/assets/css/private.scss'
import '../src/assets/css/element-variables.scss'
import '../src/assets/js/rem.js'

import BaiduMap from 'vue-baidu-map'

import $com from '../src/assets/js/common.js'

import { Button, Carousel, CarouselItem, Icon, Input, Message, Menu, Submenu, MenuItem, Image, Row, Col, Backtop, Divider, Pagination, Select, Option } from 'element-ui'
Vue.component(Icon.name, Icon)
Vue.component(Button.name, Button)
Vue.component(Input.name, Input)
Vue.component(Carousel.name, Carousel)
Vue.component(CarouselItem.name, CarouselItem)
Vue.component(Menu.name, Menu)
Vue.component(Submenu.name, Submenu)
Vue.component(MenuItem.name, MenuItem)
Vue.component(Image.name, Image)
Vue.component(Row.name, Row)
Vue.component(Col.name, Col)
Vue.component(Backtop.name, Backtop)
Vue.component(Divider.name, Divider)
Vue.component(Pagination.name, Pagination)
Vue.component(Select.name, Select)
Vue.component(Option.name, Option)

Vue.prototype.$message = Message

Vue.config.productionTip = false

// 页面设置title 1---> npm install vue-wechat-title --save 2---> <div v-wechat-title="$route.meta.title"></div>
Vue.use(require('vue-wechat-title'))
Vue.prototype.$com = $com

// ak 是在百度地图开发者平台申请的密钥
Vue.use(BaiduMap, {
  ak: '55qwWQojxrXWChXh6SdaGC5WUUaGkTdY'
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
